/**
 * Wire format of a single entry in `HubOption.mods[]`. The backend persists
 * overrides for a Hub option as an array of these records in the `mods` JSON
 * column; deserialization converts them into domain-level `*Condition[]`
 * arrays for the UI, and serialization writes them back.
 */
export type ModRule = {
  variableId: number | null;
  operator: string;
  value: string | { type: 'variable'; variableId: number };
};

export type Mod = {
  prop: string;
  sortOrder: number;
  val: Record<string, unknown>;
  when: {
    match: string;
    rules: ModRule[];
  };
};

/**
 * Mod prop values whose `val.gotoBranchId` references a destination branch.
 * Mirrors backend MOD_GOTO_PROPS in editor-api/src/controllers/hub/hub_mods_links.js.
 */
export const HUB_GOTO_PROPS = ['goto', 'replay.goto'] as const;
export type HubGotoProp = typeof HUB_GOTO_PROPS[number];

export function isHubGotoProp(prop: unknown): prop is HubGotoProp {
  return typeof prop === 'string' && (HUB_GOTO_PROPS as readonly string[]).includes(prop);
}
